export default __webpack_public_path__ + "static/media/Bmv_Books.0e1a9b91.jpg";